import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { TokenPasswordScreen } from './TokenPasswordScreen';

/**
 * Replaces `Pages/Auth/ResetPassword.cshtml`.
 *
 * The "forgot password" flow for an account that already exists and is active:
 * it sets a new password without asking for the old one, and — unlike
 * activation — leaves `IsActive` and `EmailConfirmed` alone.
 */
export function ResetPasswordPage() {
  const { t } = useTranslation();

  return (
    <TokenPasswordScreen
      validatePath="/api/auth/reset-password/validate"
      submitPath="/api/auth/reset-password"
      title={t('auth:Auth.ResetYourPassword', 'Reset Your Password')}
      subtitle={t('auth:Auth.ResetPasswordMessage', 'Enter a new password for your account.')}
      invalidSubtitle={t('auth:Auth.ResetLinkUnusable', 'This link can no longer be used.')}
      invalidMessage={
        <Trans
          i18nKey="auth:Auth.ResetLinkInvalid"
          defaults="This link is invalid or incomplete. Please request a new one from the <0>forgot password</0> page."
          components={[<Link key="0" to="/auth-forgotpassword" className="alert-link" />]}
        />
      }
      newPasswordPlaceholder={t('auth:Auth.EnterNewPassword', 'Enter a new password')}
      confirmPasswordPlaceholder={t('auth:Auth.ReEnterNewPassword', 'Re-enter your new password')}
      submitIcon="check"
      submitLabel={t('auth:Auth.ResetPassword', 'Reset Password')}
      pendingLabel={t('auth:Auth.ResettingPassword', 'Resetting password...')}
      successMessage={t('auth:Auth.PasswordResetSuccess', 'Your password has been reset. You can now log in.')}
    />
  );
}
